import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {HomeComponent} from "./components/home/home.component";
import {SupportComponent} from "./components/support/support.component";
import {PrivacyPolicyComponent} from "./components/privacy-policy/privacy-policy.component";
import {GrievanceFormComponent} from "./components/grievance-form/grievance-form.component";
import {FindADentistComponent} from "./components/find-a-dentist/find-a-dentist.component";
import {SummaryDiscountsComponent} from "./components/summary-discounts/summary-discounts.component";
import {PurchaseWidgetComponent} from "./components/purchase-widget/purchase-widget.component";
import {BenefitInfoComponent} from "./components/benefit-info/benefit-info.component";
import { AdhaComponent } from './components/adha/adha.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'purchase', component: PurchaseWidgetComponent},
  { path: 'support', component: SupportComponent},
  { path: 'adha/support', component: SupportComponent},
  { path: 'privacy', component: PrivacyPolicyComponent},
  { path: 'greivance', component: GrievanceFormComponent},
  { path: 'adha/greivance', component: GrievanceFormComponent},
  { path: 'find-a-dentist', component: FindADentistComponent},
  { path: 'adha/find-a-dentist', component: FindADentistComponent},
  { path: 'summary-of-discounts', component: SummaryDiscountsComponent},
  { path: 'adha/summary-of-discounts', component: SummaryDiscountsComponent},
  { path: 'benefit-info', component: BenefitInfoComponent},
  { path: 'adha', component: AdhaComponent } ]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
